export const PAGE_KEY = "repairLabor_v2";
export const ASSETS_PAGE_KEY = `${PAGE_KEY}_assets`;
